import { render, staticRenderFns } from "./PersonSave.vue?vue&type=template&id=b87db88a"
import script from "./PersonSave.vue?vue&type=script&lang=js"
export * from "./PersonSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports